import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { Social } from 'functions/src/types/Social';
// import { useEffect, useState } from 'react';
// import { useMoralisQuery } from 'react-moralis';
import { Timeline } from 'react-twitter-widgets';
import { SocialFeedError } from './SocialFeedError';
import { useMedia } from 'src/contexts/MediaContext';
import { TwitchChatBluMint } from './TwitchChatBluMint';
type GameSocialFeedProps = {
  handleToggle?: () => void;
  twitter: Social;
};

export function GameSocialFeed({ twitter }: GameSocialFeedProps) {
  const theme = useTheme();
  const { media, activeMediaIndex } = useMedia();
  const activeMedia = media[Number(activeMediaIndex)];

  const twitterProfileName = twitter?.link
    ?.replace('https://', '')
    .split('/')[1];
  //. const [socialEntries, setSocialEntries] = useState<Chatter[]>([]);
  // const chatterQuery = useMoralisQuery(
  //   'Chatter',
  //   (query) =>
  //     query
  //       .equalTo('game', game)
  //       .equalTo('category', 'social media')
  //       .descending('updatedAt'),
  //   [game],
  // );
  // useEffect(() => {
  //   if (chatterQuery.data && chatterQuery.data.length > 0) {
  //     setSocialEntries(chatterQuery.data as Chatter[]);
  //   }
  // }, [chatterQuery.data]);
  //TODO: change to modal view on small screens
  //TODO: add animations for opening and closing the social feed
  //TODO: figure out how to fetch the real data
  /*
        sx={{
        width: '56px',
        background: theme.palette.background.elevation[10],
        backdropFilter: 'blur(25px)',
        paddingLeft: '18px',
        paddingTop: '19px',
        backgroundClip: 'padding-box',
        '-webkitMaskRepeat': 'no-repeat',
        border: '2px solid #279BF6',
        borderRadius: '10px 0px 0px 10px',
        borderRight: 'none',
        boxShadow: theme.shadows[4],
        '&:hover': {
          boxShadow: theme.shadows[7],
        },
      }}
    ></Box>
  */
  return (
    <Box
      sx={{
        background: theme.palette.background.elevation[10],
        backdropFilter: 'blur(25px)',
        backgroundClip: 'padding-box',
        WebkitMaskRepeat: 'no-repeat',
        borderLeft: '1px solid #279BF6',
        //borderRadius: '10px 0px 0px 10px',
        borderRight: 'none',
        width: '450px',
        '& h6': {
          marginLeft: '16px',
        },
      }}
    >
      {/* <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          pt: 2,
          pb: 2,
          pl: 7,
          boxShadow: theme.shadows[7],
        }}
      >
        <GradientTypography
          variant="h5"
          gradientColor="primary.vertical"
          sx={{
            textTransform: 'uppercase',
            pb: 1,
          }}
        >
          Social Feed
        </GradientTypography>
      </Box> */}

      {activeMedia?.type === 'twitch' ? (
        <TwitchChatBluMint activeMediaUrl={activeMedia.src} />
      ) : (
        <Box
          sx={{
            overflowY: 'auto',
            pb: 3,
            height: 'calc((100vw - 450px) * 9/16 + 114px)',
          }}
        >
          <Timeline
            dataSource={{
              sourceType: 'profile',
              screenName: twitterProfileName,
            }}
            renderError={(error) => {
              return <SocialFeedError error={error} />;
            }}
            options={{
              theme: 'dark',
              tweetLimit: 20,
              width: '450',
              borderColor: '#0064E9',
              chrome: 'noheader, transparent, noscrollbar',
            }}
          />
        </Box>
      )}

      {/* <Box>
        <Box
          sx={{
            width: '480px',
            pl: 4,
            pr: 2,
            borderRadius: '5px',
            maxHeight: 'calc((100vw - 500px) * 9 / 16)',
            overflowY: 'auto',
            overflowX: 'hidden',
            display: 'block',
            ...theme.palette.scrollbars.primary,
            direction: 'rtl',
          }}
        >
          <Box sx={{ direction: 'ltr' }}>
            {socialEntries.map((entry) => (
              <SocialFeedEntry
                type={entry.attributes.socialMediaType as string}
                key={entry.id}
                post={{
                  author: {
                    name: entry.attributes.author,
                    imgUrl: entry.attributes.authorImgUrl,
                  },
                  text: entry.attributes.description,
                  engagement: entry.attributes.engagement,
                  server: entry.attributes.server,
                  videoUrl: entry.attributes.videoUrl,
                  imgUrl: entry.attributes.imgUrl,
                }}
              />
            ))}
          </Box>
        </Box>
      </Box> */}
    </Box>
  );
}
